// eslint-disable-next-line import/prefer-default-export
export const MESSAGE_ERROR_TYPES = {
  error: 'error',
  warning: 'warning',
};
